/**
 * Created by savartsov on 11/26/2016.
 */

class Sputnik {
    constructor(vue) {
        this.vm = vue;
    }

    getFeatures(query) {
        if (query) {
            /*
                Так как Спутник не имеет валидного SSL-сертификата для сервиса геокодирования,
                http://search.maps.sputnik.ru/search проксируется на /geocoder веб-сервером для работы по HTTPS
             */
            return this.vm.$http
                .get('/geocoder', {
                    params: {
                        addr_limit: 15,
                        format: 'json',
                        q: query,
                        strict: true,
                        tlat: 47.29,
                        tlon: 37.41,
                        blat: 42.89,
                        blon: 41.28
                    }
                })
                .then(response => response.body.result);
        }

    }
}

export default Sputnik;


// WEBPACK FOOTER //
// ./src/components/Sputnik.js